import { Star, Quote } from "lucide-react";
import { Reveal, Stagger, Item, SectionHead } from "./shared";
import { useI18n } from "../i18n/LanguageContext";

export const Testimonials = () => {
  const { t, c } = useI18n();
  return (
    <section id="reviews" className="py-20 sm:py-28" data-testid="testimonials-section">
      <div className="container-x">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <SectionHead eyebrow={t.testimonials.eyebrow} title={t.testimonials.title} sub={t.testimonials.sub} />
          <Reveal delay={0.1}>
            <div className="flex items-center gap-3 rounded-2xl bg-white px-6 py-4 shadow-soft">
              <div className="flex gap-0.5">{[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-gold text-gold" />)}</div>
              <div className="leading-tight">
                <p className="font-display text-lg font-semibold text-navy">4.7 / 5</p>
                <p className="text-xs text-muted">{t.testimonials.on}</p>
              </div>
            </div>
          </Reveal>
        </div>
        <Stagger className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {c.TESTIMONIALS.map((tst, i) => (
            <Item key={tst.name}>
              <div className="flex h-full flex-col rounded-3xl bg-white p-7 shadow-soft" data-testid={`testimonial-${i}`}>
                <Quote size={28} className="text-gold/40" />
                <div className="mt-4 flex gap-0.5">{[...Array(5)].map((_, s) => <Star key={s} size={13} className="fill-gold text-gold" />)}</div>
                <h4 className="mt-4 font-display text-lg font-semibold text-navy">{tst.title}</h4>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-muted">{tst.body}</p>
                <div className="mt-6 flex items-center gap-3 border-t border-navy/5 pt-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-navy font-display text-sm font-semibold text-gold-300">{tst.name.charAt(0)}</span>
                  <span className="text-sm font-medium text-navy">{tst.name}</span>
                </div>
              </div>
            </Item>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
